import { createSelector } from 'reselect';
import _ from 'lodash';
import { pendingResponse } from '../fetchStatus';

export const carBrandsResponseSelector = state => state.carBrands || pendingResponse;

export const carBrandsSelector = createSelector([carBrandsResponseSelector], carBrandsResponse => carBrandsResponse.data);

export const carBrandNamesSelector = createSelector([carBrandsSelector], carBrands => _.map(carBrands, 'marke'));
